// extracted by mini-css-extract-plugin
export var container = "ContentWithStickyColumn-module--container--84c06";
export var content = "ContentWithStickyColumn-module--content--56a66";
export var info = "ContentWithStickyColumn-module--info--646f4";
export var section = "ContentWithStickyColumn-module--section--49b48";
export var stick = "ContentWithStickyColumn-module--stick--35665";
export var title = "ContentWithStickyColumn-module--title--8d5a2";